import instance from '../../../api/axios'
import { FileItem } from '../types/files'

export const updateFile = async (
  id: string,
  data: Partial<FileItem>,
): Promise<FileItem> => {
  const response = await instance.put(`/files/${id}`, data)
  return response.data
}

export default updateFile
